import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { Client } from "@/interfaces/domain/Client";
import { AuthUser } from "@/interfaces/domain/User";

export interface AuthState {
  user: AuthUser | null;
  logged: boolean;
}

const initialState = {
  user: null,
  logged: false,
} as AuthState;

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    LOGIN: (state, action: PayloadAction<AuthUser>) => ({
      ...state,
      user: action.payload,
      logged: true,
    }),
    UPDATE_CLIENT: (state, action: PayloadAction<Client>) => ({
      ...state,
      user: { ...state.user, cliente: action.payload },
      logged: true,
    }),
    LOGOUT: () => initialState,
  },
});

export const { LOGIN, LOGOUT, UPDATE_CLIENT } = authSlice.actions;

export default authSlice.reducer;
